import { Box, Typography } from '@material-ui/core'
import { houseAmpLogo } from 'assets/index'
import { approvalActions } from 'ducks/actions'
import { useEffect } from 'react'
import { useAppDispatch } from 'ducks/hooks'
import styles from './styles.module.scss'

type Props = {
    handleRequestFinancing: () => void
}

const Financing = ({ handleRequestFinancing }: Props) => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(approvalActions.setApprovalValue({
            attr: 'showFinancingHeader', value: <Box className={styles.houseAmpLogoContainer}>
                <img src={houseAmpLogo} alt='house amp logo' className={styles.houseAmpLogo} />
            </Box>
        }))

        return () => {
            dispatch(approvalActions.setApprovalValue({
                attr: 'showFinancingHeader', value: undefined
            }))

        }
    }, [])


    return (
        <Box className={styles.container}>
            <Box className={styles.header}>
                <Typography className={styles.headerTitle}>Explore your pay-at-close financing options</Typography>
                <Typography className={styles.headerSubtitle}>HouseAmp’s platform connects homeowners with lenders for pre-listing renovation and inspection repair financing.</Typography>
            </Box>
            <Box className={styles.body}>
                <Box className={styles.bodyItem}>
                    <Typography className={styles.bodyItemTitle}>program details</Typography>
                    <ul>
                        <li>
                            <Typography className={styles.bodyItemListText}>
                                HomeSale Loan™ (equity-based, pay-later loan)
                            </Typography>
                        </li>
                        <li><Typography className={styles.bodyItemListText}>Funding up to $250k</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>No payments or out-of-pocket costs for 1st year</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>Interest-only payments months 13-23</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>24-month loan, 6-month draw period</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>Repayment due upon sale of the house, or at the maturity date, whichever comes first</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>1.99% one-time origination fee</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>60 days no-interest period</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>Minimum 650 credit score</Typography></li>
                        <li><Typography className={styles.bodyItemListText}>Minimum 25% equity in the home</Typography></li>
                    </ul>
                </Box>
                <Box className={`${styles.bodyItem} ${styles.bodyItemRight}`}>
                    <Typography className={styles.bodyItemTitle}>how it works</Typography>
                    <Box>
                        <Typography className={styles.bodyItemListText}>1. Create an account with HouseAmp and enter your project details in the “Projects” tab.</Typography>
                        <Typography className={styles.bodyItemListText}>2. Apply for the funding through the “Pay Later” tab</Typography>
                        <Typography className={styles.bodyItemListText}>3. Once approved, you will sign the service agreement with BOSSCAT and schedule the start date for your project.</Typography>
                        <Typography className={styles.bodyItemListText}>4. At the start and throughout the project, approve invoice payments in your HouseAmp account.</Typography>
                        <Typography className={styles.bodyItemListText}>5. The loan will be repaid automatically from the proceeds when the house closes.</Typography>
                        <Box onClick={handleRequestFinancing} className={styles.financingButton}>
                            <Typography className={styles.financingButtonText}>
                                Get Started with HouseAmp
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box className={styles.footer}>
                <Typography className={styles.footerText}>{`1) Loans are available through HouseAmp's licensed lending partners. All loans are subject to approval based on lenders' underwriting criteria.`}</Typography>
                <Typography className={styles.footerText}>{`2) Homeowners can apply for a 24-month open-ended home equity line of credit, which includes an origination fee, a fixed interest rate, and a limited no- interest period. The loan allows homeowners to access funds for home improvements and sale-related expenses for a draw period of up to six months. Disbursement of funds within the HouseAmp platform is subject to HouseAmp's Terms of Use.`}</Typography>
                <Typography className={styles.footerText}>{`3) Repayment of the loan, including the outstanding balance, any accrued interest, and fees, is required either upon the sale of the house or within 24 months of the origination date, whichever comes first.
Monthly interest payments will be required if the loan exceeds 12 months. The outstanding loan balance and any unpaid, accrued interest will be due on
the 24th month.`}</Typography>
            </Box>
        </Box>
    )
}

export default Financing
